
/* Hitch: desktop nav active link (blue). No flashing. */
(function(){
  function norm(href){
    try {
      var u = new URL(href, window.location.origin);
      var p = u.pathname;
      if (!p) return "/";
      // strip trailing slash except root
      if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
      return p + (u.hash || "");
    } catch(e){ return href || "/"; }
  }

  function currentHref(){
    return norm((window.location.pathname || "/") + (window.location.hash || ""));
  }

  function setActive(links, href){
    var target = norm(href);
    links.forEach(function(a){
      var ahref = norm(a.getAttribute("href") || "");
      if (ahref === target) {
        a.classList.add("is-active");
      } else {
        a.classList.remove("is-active");
      }
    });
  }

  function init(){
    var links = Array.prototype.slice.call(document.querySelectorAll(".hh-header .hh-nav a"));
    if (!links.length) return;

    function syncToLocation(){
      var current = currentHref();
      var stored = localStorage.getItem("hitch:lastNavHref");
      // Prefer exact current; fallback to stored if none matches
      var hasCurrent = links.some(function(a){ return norm(a.getAttribute("href") || "") === current; });
      setActive(links, hasCurrent ? current : (stored || current));
    }

    syncToLocation();

    // Update on click and persist
    links.forEach(function(a){
      a.addEventListener("click", function(){
        var href = a.getAttribute("href") || "/";
        localStorage.setItem("hitch:lastNavHref", href);
        setActive(links, href);
      }, { passive: true });
    });

    window.addEventListener("hashchange", syncToLocation, { passive: true });
    window.addEventListener("popstate", syncToLocation, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
